module.exports = __webpack_public_path__ + "media/images/icons/wizard/progress/top-a11978bcd7f830629bfe43906f150326.svg";